import { useLang } from "@/lib/LanguageContext";
import { aboutImage } from "@/lib/portfolio";

export default function About() {
    const { t } = useLang();

    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-20 lg:py-32"
        >
            <div className="mx-auto max-w-screen-2xl px-6 md:px-12 lg:px-20">
                <p className="overline text-terracotta mb-12">
                    {t.about.eyebrow}
                </p>

                <div className="grid grid-cols-12 gap-8 md:gap-16">
                    {/* Title */}
                    <div className="col-span-12 md:col-span-5">
                        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-navy">
                            {t.about.title}
                        </h2>

                        <div className="hidden md:block img-hover mt-12 aspect-square">
                            <img
                                src={aboutImage}
                                alt={`${t.brand.name} in front of his work`}
                                className="h-full w-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    {/* Body */}
                    <div className="col-span-12 md:col-span-7 md:pl-8">
                        <p className="text-lg leading-relaxed text-navy/85 max-w-xl">
                            {t.about.body}
                        </p>
                        {t.about.body2
                            .split(/\n\n+/)
                            .filter(Boolean)
                            .map((para, idx) => (
                                <p
                                    key={idx}
                                    className="mt-6 text-base leading-relaxed text-navy/65 max-w-xl"
                                >
                                    {para}
                                </p>
                            ))}

                        <blockquote className="mt-14 border-l border-terracotta pl-6">
                            <p className="font-serif italic text-3xl sm:text-4xl leading-tight text-navy">
                                “{t.about.quote}”
                            </p>
                            <footer className="overline text-navy/55 mt-4">
                                {t.about.quoteAttr}
                            </footer>
                        </blockquote>

                        <div className="mt-14 grid grid-cols-2 gap-8 max-w-md">
                            <div>
                                <p className="overline text-navy/50">
                                    {t.about.metaLeft}
                                </p>
                                <p className="font-serif text-2xl text-navy mt-1">
                                    {t.about.metaLeftValue}
                                </p>
                            </div>
                            <div>
                                <p className="overline text-navy/50">
                                    {t.about.metaRight}
                                </p>
                                <p className="font-serif text-2xl text-navy mt-1">
                                    {t.about.metaRightValue}
                                </p>
                            </div>
                        </div>

                        <div className="md:hidden img-hover mt-12 aspect-square">
                            <img
                                src={aboutImage}
                                alt={`${t.brand.name} in front of his work`}
                                className="h-full w-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
